import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDeviceProfileOrbiwise, IServiceProfileOrbiwise } from 'modelos/src';
import { HttpService } from '../../auxiliares/http.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class OrbiwiseService {
  constructor(private http: HttpService) {}

  public getDeviceProfiles(
    serverUrl: string,
    user: string,
    pass: string
  ): Observable<IDeviceProfileOrbiwise[]> {
    let params = new HttpParams();
    params = params.set('serverUrl', serverUrl);
    params = params.set('user', user);
    params = params.set('pass', pass);
    //
    return this.http.get(`/orbiwise/device-profiles`, { params });
  }

  public getServiceProfiles(
    serverUrl: string,
    user: string,
    pass: string
  ): Observable<IServiceProfileOrbiwise[]> {
    let params = new HttpParams();
    params = params.set('serverUrl', serverUrl);
    params = params.set('user', user);
    params = params.set('pass', pass);
    //
    return this.http.get(`/orbiwise/service-profiles`, { params });
  }
}
